import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import AdminCompanyBillingAdd from "../components/AdminCompanyBillingAdd";
import * as companyActions from "../../../../actions/company.actions";
import * as invoiceActions from "../../../../actions/invoice.actions";

class AdminCompanyBillingAddContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.companyActions.getAdminCompanyById(
      this.props.match.params.companyId
    );
    this.props.invoiceActions.getInvoiceStatus();
  }

  getProjects(projects) {
    let allowedProjects = [];

    // Status: in-progress, completed, reviewed.
    let status = [9, 12, 13];

    _.forEach(projects, project => {
      if (status.includes(project.status_id)) {
        const option = {
          id: project.id,
          value: project.title
        };
        allowedProjects.push(option);
      }
    });

    return allowedProjects;
  }

  handleSubmit(data) {
    // Update invoice
    this.props.invoiceActions.updateInvoice(
      data,
      this.props.match.params.companyId
    );
  }

  render() {
    return (
      <AdminCompanyBillingAdd
        id={this.props.match.params.companyId}
        projects={this.props.projects}
        projectOptions={this.getProjects(this.props.projects)}
        status={this.props.status}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    projects: state.company.adminCompany.projects,
    status: state.invoice.status
  };
};

const mapDispatchToProps = dispatch => ({
  companyActions: bindActionCreators(companyActions, dispatch),
  invoiceActions: bindActionCreators(invoiceActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanyBillingAddContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/company/containers/AdminCompanyBillingAddContainer.js